import React from 'react'
import { getCookie } from '../../helpers/CookieHandler'
import StabilityTool_common from './StabilityTool_common'
import StabilityTool_UK from './StabilityTool_UK'


class StabilityTool extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      selectedCountry : getCookie('welcomeCountryLabel')
    }
  }

  render() {
    if(this.state.selectedCountry.toLowerCase() === "united kingdom") {
      return (
        <StabilityTool_UK />
      )
    } else {
      return (
        <StabilityTool_common />
      )
    }    
  }
}

export default StabilityTool



// WEBPACK FOOTER //
// ./src/mi-app/stabilityTool/StabilityTool.js